// extracted by mini-css-extract-plugin
module.exports = {"swiper":"billboard-slider_swiper__6WcIg"};